import { CodedProperty, NamedProperty, ResolutionProperty } from "sprint-common-web";

import { OnPremOrderStatus } from "../../../../orders/common/types/OnPremOrderStatus";
import { OrderAssetAvailability } from "../../../../orders/common/types/OrderAssetAvailability";
import { AuditInfo } from "../../../types/AuditInfo";
import { OrderContentReference } from "../../../types/OrderContentReference";

export interface GetOnPremOrderListResponse {
    items: OnPremOrderListResponseItem[];
    totalCount: number;
}

export interface OnPremOrderListResponseItem {
    id: string;
    content: OrderContentReference;
    airline: CodedProperty;
    systemPlatform: SystemPlatformReference;
    status: OnPremOrderStatus;
    startDate: string;
    dueDate: string;
    audit: AuditInfo;
    onPremAssets: OnPremOrderAssetsResponse;
    targetResolution?: ResolutionProperty;
    targetFilenames: string[];
    pONumber: string;
    buzzId?: string;
    isTrailer?: boolean;
    isRevised?: boolean;
    runtime?: string;
    source: OnPremOrderSource;
}

export enum OnPremOrderSource {
    Shreq = 1,
    Buzz = 2
}

interface OnPremOrderAssetsResponse {
    video: OnPremOrderVideoListingItemResponse;
    soundtracks: OnPremOrderSoundtrackListingItemResponse[];
    subtitles: OnPremOrderSubtitleListingItemResponse[];
}

export interface OnPremOrderVideoListingItemResponse {
    targetFilename: string;
    aspectRatio: NamedProperty;
    availability: OrderAssetAvailability;
    resolution?: ResolutionProperty;
    nonMatchingVideos: OnPremOrderNonMatchingVideoResponse[];
}

export interface OnPremOrderNonMatchingVideoResponse {
    assetId: string;
    subtitle: CodedProperty;
    aspectRatio: NamedProperty;
    sourceResolution: ResolutionProperty;
}

export interface OnPremOrderSoundtrackListingItemResponse {
    language: CodedProperty;
    availability: OrderAssetAvailability;
}

export interface OnPremOrderSubtitleListingItemResponse {
    language: CodedProperty;
    availability: OrderAssetAvailability;
    isEmbedded: boolean;
    targetFilename?: string;
}

interface SystemPlatformReference {
    system: NamedProperty;
}
